exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2r1AOFuDuhJG8nW-GZiq7o{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2r1AOFuDuhJG8nW-GZiq7o ._2jsH0O0DC5ZwUPKC9uM1Fp{font-size:28px;color:\"[theme:themeTertiary, default:#71AFE5]\";display:block}._2r1AOFuDuhJG8nW-GZiq7o .bf4L0KBB_aengHfMmM1wc{font-size:28px;font-weight:600;color:\"[theme:white, default:#ffffff]\"}html[dir] ._2r1AOFuDuhJG8nW-GZiq7o .bf4L0KBB_aengHfMmM1wc{margin:12px}", ""]);

// exports
exports.locals = {
	"guidance": "_2r1AOFuDuhJG8nW-GZiq7o",
	"chevron": "_2jsH0O0DC5ZwUPKC9uM1Fp",
	"message": "bf4L0KBB_aengHfMmM1wc"
};